<div
  class="visual-builder-block"
  [class.selected]="selectedId?.id?.includes(feedId)"
>
  <div
    class="movement-block"
    [ngClass]="'movement-block-products-feed'"
    [ngStyle]="{
      boxShadow: productFeed?.shadow,
      borderColor: productFeed?.borderColor,
      'borderWidth.px': productFeed?.borderWidth,
      'borderRadius.px': productFeed?.borderRadius
    }"
    (click)="selectProductFeed($event, prevBtn, nextBtn)"
  >
    <div
      class="movement-block-content position-relative"
      [ngStyle]="{
        backgroundColor: productFeed?.backgroundColor,
        borderLeftColor: productFeed?.backgroundColor || '#ced2dc',
        borderRightColor: productFeed?.backgroundColor || '#ced2dc'
      }"
    >
      <div *ngIf="!destroy && (productItems.length > 0 || !isVisualBuilder)">
        <swiper
          *ngIf="productItems.length > 0; else noItems"
          (swiper)="initSwiper()"
          [breakpoints]="swiperConfig.breakpoints"
          [slidesPerView]="swiperConfig.slidesPerView"
          [spaceBetween]="swiperConfig.spaceBetween"
          [centeredSlides]="swiperConfig.centeredSlides"
          [loop]="
            swiperConfig.loop &&
            productItems.length >= swiperConfig.breakpoints['767'].slidesPerView
          "
          [centerInsufficientSlides]="true"
          [autoplay]="{ delay: productFeed.sliderOptions.autoplayDelay }"
          [navigation]="navigationOptions"
          [class]="feedId + 'Swiper'"
          [id]="feedId"
          #swiper
        >
          <ng-template swiperSlide *ngFor="let productItem of productItems">
            <app-tracking-page-products-feed-item
              [productItem]="productItem"
              [itemStyles]="productFeed.card"
              [placement]="feedId.replace('ProductsFeed', '')"
              [selectedId]="selectedId"
              (selectBlock)="selectProductFeed($event, prevBtn, nextBtn)"
              [isVisualBuilder]="isVisualBuilder"
            ></app-tracking-page-products-feed-item>
          </ng-template>
        </swiper>
      </div>
      <div
        *ngIf="destroy"
        class="position-relative"
        style="width: 100%; height: 314px"
      >
        <div class="loader inner-right-img text-center">
          <div>
            <img class="img-fluid" src="/assets/img/spinner.gif" />
            <p class="loading">Loading</p>
          </div>
        </div>
      </div>
      <div
        #nextBtn
        class="{{ feedId }} swiper-button-next"
        [class.hide]="productItems.length < 1"
        [ngStyle]="arrowsStyles('right')"
      ></div>
      <div
        #prevBtn
        class="{{ feedId }} swiper-button-prev"
        [class.hide]="productItems.length < 1"
        [ngStyle]="arrowsStyles('left')"
      ></div>
      <ng-template #noItems>
        <p class="mat-error text-center">
          Please add slides or disable the slider
        </p>
      </ng-template>
    </div>
    <!-- /movement-block-content -->
  </div>
</div>
